<div class="login-page">
  <div class="login-container">
    <div class="left-section image-section">
      <img src="assets/azeapp.png" alt="Login Banner">
    </div>

    <div class="right-section">
      <div class="login-box">
        <div class="login-header">
          <h1>Sign In</h1>
          <p>Enter your credentials to access your account</p>
        </div>

        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
          <div class="form-group">
            <label for="userName">Username</label>
            <div class="input-container">
              <i class="fas fa-user"></i>
              <input
                type="text"
                id="userName"
                formControlName="userName"
                placeholder="Enter your username"
                [class.error]="loginForm.get('userName')?.invalid && loginForm.get('userName')?.touched"
              />
            </div>
            <div class="error-message" *ngIf="loginForm.get('userName')?.invalid && loginForm.get('userName')?.touched">
              {{ getErrorMessage('userName') }}
            </div>
          </div>

          <div class="form-group">
            <label for="password">Password</label>
            <div class="input-container">
              <i class="fas fa-lock"></i>
              <input
                [type]="hidePassword ? 'password' : 'text'"
                id="password"
                formControlName="password"
                placeholder="Enter your password"
                [class.error]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched"
              />
              <i
                class="password-toggle"
                [class]="hidePassword ? 'fas fa-eye' : 'fas fa-eye-slash'"
                (click)="hidePassword = !hidePassword"
              ></i>
            </div>
            <div class="error-message" *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
              {{ getErrorMessage('password') }}
            </div>
          </div>

          <div class="form-options">
            <div class="remember-me">
              <input type="checkbox" id="remember">
              <label for="remember">Remember me</label>
            </div>
            <!-- <a href="#" class="forgot-password">Forgot Password?</a> -->
          </div>

          <button
            type="submit"
            [disabled]="loginForm.invalid || isLoading"
            class="login-button"
          >
            <span *ngIf="!isLoading">Sign In</span>
            <div class="loader" *ngIf="isLoading"></div>
          </button>
        </form>

        <!-- <div class="register-prompt">
          <p>Don't have an account? <a href="#">Create Account</a></p>
        </div> -->
        <div class="register-guide">
          <p class="guide-text">Don't have an account?</p>
          <p class="sub-text">Start by completing the Application Form:</p>
        
          <div class="form-links">
            <a href="/membership-form" class="btn-form app">Application Form</a>
            <span class="arrow">→</span>
            <a href="/enrolment-form" class="btn-form enrol">Enrolment Form</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> 
